<template>
  <div class="page">
    <div class="m-page">
      <div class="x-flex-between">
        <div>
          <span class="x-font-color x-font-15 m-user">用户注册</span>
        </div>
        <span class="x-font-12">{{keys}}/2</span>
      </div>
      <p class="m-p">{{titleName}}</p>
      <transition name="van-fade">
        <mTabNav1 ref="mTab1" v-show="keys==1" :isRegister="1" @isOK="isOK"/>
      </transition>
      <transition name="van-fade">
        <mTabNav2 ref="mTab2" v-show="keys==2" :isRegister="1" @isOK="isOK" @submit="submit"/>
      </transition>
      <!--<transition name="van-fade">-->
        <!--<m-tab-nav3 ref="mTab3" v-show="keys==3" @isOK="isOK" @submit="submit"/>-->
      <!--</transition>-->
      <div class="m-bottom-footer">
        <p>已有账号 <span class="x-font-color" @click="$router.replace('/login')">去登录</span></p>
      </div>
    </div>
  </div>
</template>

<script>
  import mTabNav1 from "./components/m-tab-nav1"
  import mTabNav2 from "./components/m-tab-nav2"
  import mTabNav3 from "./components/m-tab-nav3"
  export default {
    components: {mTabNav1,mTabNav2,mTabNav3},
    data () {
      return {
        keys:1,
        titleName:'',
      }
    },
    created () {
      this.getTitle()
    },
    methods: {
      isOK(i){
        this.keys = i
      },
      //立即注册
      submit(){
        let form1 = this.$refs.mTab1.form
        let form2 = this.$refs.mTab2.form
        let params = Object.assign({}, form1, form2)
        this.http.postRequest({
          url:'app/userInfo/insert',
          msg:params,
          success:(res)=>{
            this.utils.toastSuccess('注册成功!')
            this.$router.replace({
             path:'/login'
            })
          }
        },true)
      },
      getTitle(){
        this.http.getRequest({
          url:'app/userInfo/tenantNoLogin',
          msg:{},
          success:(res)=>{
            this.titleName = res.data.studentTitle
          }
        })
      },
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .page{
    background: #F4F6F9;
    .m-page{
      position: absolute;
      top: 12px;
      left: 12px;
      right: 12px;
      bottom: 12px;
      margin: auto;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      z-index: 2;
      background: #ffffff;
      border-radius: 4px;
      padding: 15px;
      .m-user{
        border-left: 3Px solid #457DF9;
        padding-left: 4px;
      }
      .m-p{
        margin-top: 8px;
        font-size: 12px;
        color: #1D232D;
        margin-bottom: 20px;
      }
      .m-bottom-footer{
        padding-top: 30px;
        /*position: absolute;*/
        /*left: 0;*/
        /*right: 0;*/
        /*bottom: 40px;*/
        /*z-index: 10;*/
        line-height: 15px;
        >p{
          text-align: center;
          font-size: 14px;
        }
      }
    }
  }
</style>

